export default __webpack_public_path__ + "static/maria-3252d6608734047a302e017f4a6d6a9d.png";